import { render, staticRenderFns } from "./sblx.vue?vue&type=template&id=81616782&scoped=true&"
import script from "./sblx.vue?vue&type=script&lang=js&"
export * from "./sblx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81616782",
  null
  
)

export default component.exports